import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H15V27C15 27.5523 15.4477 28 16 28C16.5523 28 17 27.5523 17 27V17H27C27.5523 17 28 16.5523 28 16C28 15.4477 27.5523 15 27 15H17V5Z" })
});
export default SvgPlus;
